import React, {Component, Fragment} from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
} from 'reactstrap';

class ElementCardActions extends Component {
  constructor(props) {
    super(props);
    this.state = {dropdownOpen: false};
  }

  // ----------------------
  // State setters
  // ----------------------

  toggle() {
    this.setState({dropdownOpen: !this.state.dropdownOpen});
  }

  render() {
    return (
      <Fragment>
        {this.props.showActions &&
        <Fragment>
          <div className="element-cards-actions">
            {this.props.actions.canEdit &&
            <button type="button" className="button small secondary" onClick={() => this.props.onAction('edit')}>
              <i className="fa fa-edit"/>
              Edit </button>
            }
            {this.props.actions.canMoveUp &&
            <button type="button" className="button small primary" onClick={() => this.props.onAction('moveUp')}>
              <i className="fa fa-chevron-up"/>
              Move up </button>
            }
            {this.props.actions.canMoveDown &&
            <button type="button" className="button small primary" onClick={() => this.props.onAction('moveDown')}>
              <i className="fa fa-chevron-down"/>
              Move Down
            </button>
            }
            {this.props.actions.canDelete &&
            <button type="button" className="button small primary" onClick={() => this.props.onAction('delete')}>
              <i className="fa fa-remove"/>
              Delete
            </button>
            }
          </div>
        </Fragment>
        }
      </Fragment>
    );
  }
}

export default ElementCardActions;
